import { SvgIcon, SvgIconProps } from "@mui/material";

const SettingsIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4444_9945)">
      <path
        d="M0 2H6M6 2H8M6 2V0M6 2V4M8 6H2M2 6H0M2 6V4M2 6V8"
        stroke="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4444_9945">
        <rect width="8" height="8" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default SettingsIcon;
